export const menuItemsComTestesJson = ([
  {
    id: "home",
    name: "Página inicial",
    icon: "fas fa-home",
    url: "/" + import.meta.env.VITE_APP_BASE,
  },
  {
    id: "pj",
    name: "Pessoa Jurídica",
    icon: "fas fa-building",
    children: [
      {
        id: "pjCadastrar",
        name: "Cadastrar",
        icon: "fas fa-plus-circle",
        url: "/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-cadastrar",
      },
      {
        id: "pjConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-consultar",
      },
      {
        id: "pjSelOp",
        name: "Operações",
        icon: "fa fa-hourglass-start",
        url: "/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-consultar/operacoes",
      },
    ],
  },
  {
    id: "efpc",
    name: "Entidades",
    icon: "fas fa-hand-holding-heart",
    children: [
      {
        id: "efpcTesteCadastrar",
        name: "Teste Cadastrar",
        // icon: "fas fa-users",
        icon: "fas fa-plus-circle",
        url: "/" + import.meta.env.VITE_APP_BASE + "/efpc-cadastrar/efpc",
      },
      {
        id: "efpcConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/efpc-consultar",
      },
      {
        id: "efpcSelOp",
        name: "Operações",
        icon: "fa fa-hourglass-start",
        url: "/" + import.meta.env.VITE_APP_BASE + "/efpc-consultar/operacoes",
      },
    ]
  },
  {
    id: "plano",
    name: "Planos de Benefícios",
    icon: "fas fa-users",
    children: [
      {
        id: "planoTesteCadastrar",
        name: "Teste Cadastrar",
        icon: "fas fa-plus-circle",
        url: "/" + import.meta.env.VITE_APP_BASE + "/plano-cadastrar/plano",
      },
      {
        id: "planoConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/plano-consultar",
      },
    ]
  },
  {
    id: "convenio",
    name: "Convênio de Adesão",
    icon: "fa-regular fa-building-user",
    children: [
      {
        id: "convenioTesteCadastrar",
        name: "Teste Cadastrar",
        // icon: "fas fa-users",
        icon: "fas fa-plus-circle",
        url: "/" + import.meta.env.VITE_APP_BASE + "/convenio-cadastrar/convenio",
      },
      {
        id: "convenioConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/convenio-consultar",
      },
    ]
  },
  {
    id: "ctrldoc",
    name: "Admin DOC",
    // icon: "fas fa-users",
    icon: "fa-regular fa-building-user",
    url: "/" + import.meta.env.VITE_APP_BASE + "/ctrldoc",
  },
  {
    id: "tipoDocumentoCrud",
    name: "Tipo Documento",
    // icon: "fas fa-users",
    icon: "fa-regular fa-building-user",
    url: "/" + import.meta.env.VITE_APP_BASE + "/tipo-documento-crud",
  },
  {
    id: "documentoCrud",
    name: "Tabelas Documenos",
    // icon: "fas fa-users",
    icon: "fa-regular fa-building-user",
    url: "/" + import.meta.env.VITE_APP_BASE + "/documento-crud",
  },
  {
    id: "testeapi",
    name: "Teste API",
    // icon: "fas fa-users",
    icon: "fa-regular fa-building-user",
    url: "/" + import.meta.env.VITE_APP_BASE + "/teste-api",
  },
  {
    id: "pdf",
    name: "Emite PDF",
    icon: "fas fa-users",
    url: "/" + import.meta.env.VITE_APP_BASE + "/onlyPdf",
  }

  // {
  //   id: "org",
  //   name: "Organizações",
  //   icon: "fas fa-building",
  //   url: "/" + import.meta.env.VITE_APP_BASE + "/organizacao/buscar",
  // },
  // {
  //   id: "app",
  //   name: "Aplicações",
  //   icon: "fas fa-desktop",
  //   url: "/" + import.meta.env.VITE_APP_BASE + "/aplicacao/buscar",
  // },
]);

export const menuItemsJson = ([
  {
    id: "home",
    name: "Página inicial",
    icon: "fas fa-home",
    url: "/" + import.meta.env.VITE_APP_BASE,
  },
  {
    id: "pj",
    name: "Pessoa Jurídica",
    // icon: "fas fa-users",
    icon: "fas fa-building",
    children: [
      {
        id: "pjCadastrar",
        name: "Cadastrar",
        // icon: "fas fa-users",
        icon: "fas fa-plus-circle",
        url: "/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-cadastrar",
      },
      {
        id: "pjConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-consultar",
      },
      {
        id: "pjSelOp",
        name: "Operações",
        icon: "fa fa-hourglass-start",
        url: "/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-consultar/operacoes",
      },
    ],
  },
  {
    id: "efpc",
    name: "Entidades",
    icon: "fas fa-hand-holding-heart",
    children: [
      {
        id: "efpcConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/efpc-consultar",
      },
      {
        id: "efpcSelOp",
        name: "Operações",
        icon: "fa fa-hourglass-start",
        url: "/" + import.meta.env.VITE_APP_BASE + "/efpc-consultar/operacoes",
      },
    ]
  },
  {
    id: "plano",
    name: "Planos de Benefícios",
    icon: "fas fa-users",
    children: [
      {
        id: "planoConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/plano-consultar",
      },
    ]
  },
  {
    id: "pdf",
    name: "Emite PDF",
    icon: "fas fa-users",
    url: "/" + import.meta.env.VITE_APP_BASE + "/onlyPdf",
  }
  
]);

export const menuItemsExternoJson = ([
  {
    id: "home",
    name: "Página inicial",
    icon: "fas fa-home",
    url: "/" + import.meta.env.VITE_APP_BASE,
  },
  {
    id: "pj",
    name: "Pessoa Jurídica",
    icon: "fas fa-building",
    children: [
      {
        id: "pjConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-consultar",
      },
    ],
  },
  {
    id: "efpc",
    name: "Entidades",
    icon: "fas fa-hand-holding-heart",
    children: [
      {
        id: "efpcConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/efpc-consultar",
      },
    ]
  },
  {
    id: "plano",
    name: "Planos de Benefícios",
    icon: "fas fa-users",
    children: [
      {
        id: "planoConsultar",
        name: "Consultar",
        icon: "fas fa-eye",
        url: "/" + import.meta.env.VITE_APP_BASE + "/plano-consultar",
      },
    ]
  }
]);
